"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = void 0;
var ActionType;
(function (ActionType) {
    ActionType[ActionType["SetItem"] = 0] = "SetItem";
    ActionType[ActionType["ClearItems"] = 1] = "ClearItems";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
